const RAW = (import.meta.env.VITE_CDN_BASE as string | undefined) ?? ''
export const CDN_BASE = RAW.replace(/\/$/, '')

export function cdn(path: string): string {
  if (!path) return path
  if (/^(?:https?:)?\/\//.test(path)) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (CDN_BASE && (normalized === CDN_BASE || normalized.startsWith(`${CDN_BASE}/`))) {
    return normalized
  }
  return `${CDN_BASE}${normalized}`
}